import { Injectable } from '@angular/core';
import { Response } from "@angular/http";

import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

import { Observable } from "rxjs/Observable";
import "rxjs/Rx";

import { Observer } from "rxjs/Observer";
import { iALSCauses } from "../../../interfaces/lookups/ALS/iALSCause";
import { AuthHttp } from "angular2-jwt";
import { environment } from "../../../../environments/environment";

@Injectable()
export class ALSCauseResolver implements Resolve<iALSCauses> {
    constructor(private authHttp: AuthHttp) { }

    private alsCauses: iALSCauses = null;

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<iALSCauses> | Promise<iALSCauses> | iALSCauses {
        return Observable.create((observer: Observer<iALSCauses>) => {
            if (this.alsCauses != null) {
                observer.next(this.alsCauses);
                observer.complete();
            } else {
                const qs = environment.apiPath + '/api/lookups/getALSCauses?languageId=1';

                this.authHttp.get(qs)
                    .map(
                    (response: Response) => {
                        return response.json();
                    }).subscribe(
                    (response: any) => {
                        if (response.responseInfo.isError) {
                            this.alsCauses = new iALSCauses(response.responseInfo.message);
                        } else {
                            this.alsCauses = new iALSCauses(null);
                            this.alsCauses.list = response.list;
                        }

                        observer.next(this.alsCauses);
                        observer.complete();
                    },
                    (error: Error) => {
                        this.alsCauses = null;

                        observer.next(new iALSCauses(error.message));
                        observer.complete();
                    });
            }
        });
    }
}


// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/services/lookups/als/als-couse-resolver.service.ts